import React from "react";

function FontIcon(props) {
    return <span className="material-symbols-outlined">{props.icon}</span>;
}

export default FontIcon;
